import React from "react";
import {RotateCcw} from "lucide-react";
import {precise} from "./DecimalCell";

const CONV={INTERIOR_APERTURE:"apertura interna",ROTATION:"rotazione"};
const SRC={OWNER_DECISION:"scelta dell'utente",SECTION_GEOMETRY:"dedotta dalla sezione",SYMMETRIC_90:"90°, convenzione indifferente"};

export const BendAngleConventions=({ctx,code,angles})=>{
  if(!angles.length) return null;
  const path=id=>`components/${code}/bend_angle_conventions/${id}`;
  return <div className="qw-bend-angles" data-testid={`quote-bend-angles-${code}`}>
    {angles.map(a=><small key={a.bend_id} data-testid={`quote-bend-angle-${code}-${a.bend_id}`} data-status={a.status}>
      Piega {a.bend_id}: {precise(a.value_deg,2)}° letto{a.status==='RESOLVED'
        ?<> → {CONV[a.convention]} ({SRC[a.convention_source]||a.convention_source}){a.convention_source!=='SYMMETRIC_90'&&<>: rotazione {precise(a.theta_deg,2)}°, apertura {precise(a.interior_deg,2)}°</>}
          {a.convention_source==='OWNER_DECISION'&&<button type="button" data-testid={`quote-bend-angle-reset-${code}-${a.bend_id}`} disabled={!ctx.canSave} onClick={()=>ctx.update(path(a.bend_id),null)}><RotateCcw size={12}/>Ripristina</button>}</>
        :<> senza convenzione — <strong>convenzione da confermare</strong>: è
          <button type="button" data-testid={`quote-bend-angle-aperture-${code}-${a.bend_id}`} disabled={!ctx.canSave} onClick={()=>ctx.update(path(a.bend_id),'INTERIOR_APERTURE')}>Apertura interna ({precise(a.value_deg,2)}° fra le facce)</button>
          <button type="button" data-testid={`quote-bend-angle-rotation-${code}-${a.bend_id}`} disabled={!ctx.canSave} onClick={()=>ctx.update(path(a.bend_id),'ROTATION')}>Rotazione ({precise(a.value_deg,2)}° di piega)</button>?</>}
    </small>)}
  </div>;
};
